import { Column, Formatter } from 'angular-slickgrid';
import * as moment from 'moment';

export const GridDateFormatter: Formatter = (row: number, cell: number, value: any, columnDef: Column, dataContext: any): string => {
  let formatedDate, date, dateObject, time;
  if (value) {
    if (value instanceof Date) {
      dateObject = value;
      dateObject = moment(dateObject).format(columnDef['dateFormat']);
    } else if (columnDef.internalColumnEditor.params && columnDef.internalColumnEditor.params.configs &&                     columnDef.internalColumnEditor.params.configs.pickerType === 'timer') {
      const timeParts = value ? value.split(':') : '';
      if (timeParts && timeParts.length) {
        const today = new Date();
        today.setHours(parseInt(timeParts[0]))
        today.setMinutes(parseInt(timeParts[1]));
        dateObject = today;
      }
      dataContext[columnDef.field] = value ? value : '';
      formatedDate = value;
    } else {
      const dateArray = value.split(' ');
      let timeParts;
      date = dateArray[0];
      const dateParts = date.split('/');

      if (columnDef['timeField']) {
        time = dataContext[columnDef['timeField']];
        time = dateArray[1] ? dateArray[1] : (time ? time : '00:00');
        timeParts = time.split(':');
        dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]);
        formatedDate = date + ' ' + time;
        dataContext[columnDef['timeField']] = time ? time : '00:00';
      } else {
        dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        formatedDate = date;
      }


      // Set formated date and time
      dataContext[columnDef.field] = date ? date : '';
    }
    if (columnDef['internalColumnEditor'] && columnDef['internalColumnEditor'].params) {
      columnDef['internalColumnEditor'].params.configs.model = dateObject ? dateObject : '';
    }

  } else {
    if (columnDef['internalColumnEditor'] && columnDef['internalColumnEditor'].params) {
      columnDef['internalColumnEditor'].params.configs.model = '';
    }
    dataContext[columnDef.field] = '';
    if (columnDef['timeField']) {
      dataContext[columnDef['timeField']] = '';
    }
  }
  return `<span>${value ? formatedDate : ''}</span>`;
};
